import React from 'react';
import LiveFaceMarker from './LiveFaceMarker';
import JewelleryTryOn from './JewelleryTryOn';
import Display from './Display';
import LivePoseMarker from './LivePoseMarker';

function App() {
  return (
    // <Display />
    <JewelleryTryOn />
    // <LiveFaceMarker />
    // <LivePoseMarker />
  );
}

export default App;
